<mat-form-field color="primary" class="px-4 text-xs w-full" [appearance]="appearance" [floatLabel]="floatLabel">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    (selectionChange)="selectionChanged($event)"
    [formControl]="control"
    [disabled]="disabled"
    [multiple]="multiple"
    [placeholder]="placeholder"
  >
    <mat-option *ngFor="let item of items" [value]="item">
      <span class="text-xs">{{ item[propId] }}</span></mat-option
    >
  </mat-select>
</mat-form-field>
<div [ngClass]="{ 'mx-4': multiple }" *ngIf="multiple">
  <mat-chip-list>
    <ng-container *ngFor="let option of control.value">
      <mat-chip>
        {{ option[this.propId] }}
      </mat-chip>
    </ng-container>
  </mat-chip-list>
</div>
